import jollofRice from  './jollofRice.jpg';
import poutine1 from './poutine1.jpg';
import ricePlanta from './ricePlanta.jpg';
import starchBanga from './starchBanga.jpg';
import samosa from './samosa.jpg';
import taccos from './taccos.JPG';


const foodMenu = [
    {
      id: 1,
      name: 'Jollof Rice',
      description: 'A popular West African dish made with rice, tomatoes, onions, and a blend of spices. It is known for its vibrant red color and savory flavor.',
      src: jollofRice
    },
    {
      id: 2,
      name: 'White Rice and Plantain',
      description: 'A classic combination of steamed white rice served with ripe fried plantains. The sweetness of the plantains complements the simplicity of the rice.',
      src: ricePlanta
    },
    {
      id: 3,
      name: 'Starch and Banga Soup',
      description: 'Starch is a Nigerian staple made from cassava, served with a flavorful palm nut soup known as Banga Soup. It is often enjoyed with assorted meats and fish.',
      src: starchBanga
    },
    {
      id: 4,
      name: 'Samosa',
      description: 'A popular Indian snack consisting of a triangular pastry filled with spiced potatoes, peas, and sometimes meat. It is typically deep-fried until golden and crispy.',
      src: samosa
    },
    {
      id: 5,
      name: 'Tacos',
      description: 'A Mexican dish composed of a corn or wheat tortilla folded or rolled around a filling, which can include ingredients such as meat, beans, cheese, and salsa.',
      src: taccos
    },
    {
      id: 7,
      name: 'Poutine',
      description: 'A Canadian dish consisting of French fries topped with cheese curds and smothered in gravy. It is a hearty and indulgent comfort food.',
      src: poutine1
    }
  ];

  export default foodMenu
  